import { Capacitor } from "@capacitor/core";
import { UAParser } from "ua-parser-js";

export function isNativeIOSPlatform() {
  return Capacitor.getPlatform() === "ios";
}

export function isNativePlatform() {
  return Capacitor.getPlatform() !== "web";
}

export function isWebPlatform() {
  return Capacitor.getPlatform() === "web";
}

export function isSafariBrowser(): boolean {
  const parser = new UAParser(window.navigator.userAgent);
  const browserName = parser.getBrowser().name;
  return browserName === "Safari";
}

function getOSInfo() {
  const parser = new UAParser(window.navigator.userAgent);
  return parser.getOS();
}

export function isWebIOSPlatform(): boolean {
  const os = getOSInfo();
  return isWebPlatform() && os.name === "iOS";
}

export function isWebAndroidPlatform(): boolean {
  const os = getOSInfo();
  return isWebPlatform() && os.name === "Android";
}
